import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";
import { deactivateOfficeApplianceBrands } from "../api/deactivateOfficeApplianceBrands";

const useDeactivateOfficeAppliancesBrand = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[]) => deactivateOfficeApplianceBrands(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetOfficeApplianceBrands"]);
        toast.fire("Success", "Brand were deactivated successfully", "success");
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Brands failed",
          "Server Error: Cannot deactivate Brands",
          "error"
        );
      },
    }
  );

  return mutate;
};

export default useDeactivateOfficeAppliancesBrand;
